import * as React from 'react';
import NextPreviousButtons from '../NextPreviousButtons';
import {
	TextInput
} from '../../../../components/forms';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (value?: {}) => void;
	onQuestionnaireChange: (value?: {}) => void;
	onQuestionnaireNumberKeyUp: (value?: {}) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
}
const TaxQuestion: React.StatelessComponent<Props> = props => {
	const isNextDisabled = function () {
		var valid = false;
		// Using "truthyness"
		if (props.questionnaire.annualIncome && props.questionnaire.householdIncome) {
			valid = true;
		}
		return !valid;
	};
	return (
		<div>
			<div>
				<TextInput
					labelText={props.questions.annualIncome}
					name="annualIncome"
					type="tel"
					addOnBefore="$"
					value={props.questionnaire.annualIncome}
					onBlur={props.onQuestionnaireBlur}
					onChange={props.onQuestionnaireChange}
					onKeyUp={props.onQuestionnaireNumberKeyUp}
				/>
			</div>
			<div>
				<TextInput
					labelText={props.questions.householdIncome}
					name="householdIncome"
					type="tel"
					addOnBefore="$"
					value={props.questionnaire.householdIncome}
					onBlur={props.onQuestionnaireBlur}
					onChange={props.onQuestionnaireChange}
					onKeyUp={props.onQuestionnaireNumberKeyUp}
				/>
			</div>
			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
	);
};

export default TaxQuestion;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/lifestyleQuestions/taxQuestion.tsx